var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/upload@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/upload",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uE09A",
    transform: "translate(14, 13.0033)",
    fill: "#2C2C2C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25,9.99665414 C13.6640625,9.99665414 14,10.3325916 14,10.7466541 L14,12.9966541 C14,14.6535288 12.6568747,15.9966541 11,15.9966541 L3,15.9966541 C1.34312487,15.9966541 0,14.6535288 0,12.9966541 L0,10.7466541 C0,10.3310295 0.335625172,9.99665414 0.75,9.99665414 C1.1640625,9.99665414 1.5,10.3325916 1.5,10.7466541 L1.5,12.9966541 C1.5,13.8216539 2.17500019,14.4966541 3,14.4966541 L11,14.4966541 C11.8250003,14.4966541 12.5,13.8216539 12.5,12.9966541 L12.5,10.7466541 C12.5,10.3310295 12.8343759,9.99665414 13.2500005,9.99665414 L13.25,9.99665414 Z M6.48750067,0.200997931 C6.77500057,-0.0714706354 7.22500038,-0.0714706354 7.51368761,0.228841407 L11.7636876,4.2007166 C11.9209065,4.34821664 11.9999971,4.54743539 11.9999971,4.74665414 C11.9999971,4.93102894 11.9312501,5.11540375 11.795938,5.26068459 C11.5125003,5.56243478 11.0380006,5.57709084 10.7362504,5.29290353 L7.75000048,2.48290406 L7.75000048,10.2747789 C7.75000048,10.6607166 7.41250038,10.9966541 6.99999707,10.9966541 C6.58750057,10.9966541 6.25000048,10.6622788 6.25000048,10.2454039 L6.25000048,2.48290406 L3.26375055,5.29137288 C2.96187544,5.57540379 2.48725033,5.56090413 2.20406294,5.25915394 C1.92000055,4.95915375 1.93375063,4.48415433 2.23750067,4.17287217 L6.48750067,0.200997931 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.94a847c9d290103f7fd8159b6e3cb8e0.svg";
export { ForwardRef as ReactComponent };